module.exports = __webpack_public_path__ + "static/media/dinheiro-pagseguro.6fd887e4.png";